export enum AppCategories {
  UNSPECIFIED = 0,
  PRIVACY = 1,
  ASSET_APP = 2,
  IDENTITY = 3,
}
